<template>
	<v-container>
		<PageTitle
		icon="mdi-file-chart-outline"
		main="Relatorios"
		sub="Analise de ponto e banco de horas"
		/>

		<v-card flat class="reports-tabs-card mb-3">
			<v-tabs v-model="abaAtiva" background-color="transparent" color="primary" show-arrows>
				<v-tab href="#ponto">
					<v-icon left small>mdi-file-chart-outline</v-icon>
					Ponto
				</v-tab>
				<v-tab href="#banco-horas">
					<v-icon left small>mdi-bank</v-icon>
					Banco de Horas
				</v-tab>
			</v-tabs>
		</v-card>

		<v-tabs-items v-model="abaAtiva" class="transparent-tabs">
			<v-tab-item value="ponto">

		<!-- ================= FILTROS ================= -->
		

		<v-card flat class="mb-3">
			<v-card-text class="pa-3">
				<v-row align="center" class="filters-mode-row" no-gutters>
					<v-col class="col-fixed col-mode">
						<v-switch
						v-model="tipoFiltro"
						false-value="mensal"
						true-value="periodo"
						:label="tipoFiltro === 'periodo' ? 'Periodo' : 'Mensal'"
						dense
						hide-details
						class="ma-0 report-toggle"
						prepend-icon="mdi-calendar-range"
						/>
					</v-col>

					<v-col class="col-fixed col-mode">
						<v-switch
						v-model="modoRelatorio"
						false-value="completo"
						true-value="resumo"
						:label="modoRelatorio === 'resumo' ? 'Resumo' : 'Completo'"
						dense
						hide-details
						class="ma-0 report-toggle"
						prepend-icon="mdi-file-eye-outline"
						/>
					</v-col>

					<v-col class="col-fixed col-toggle">
						<v-switch
						v-model="check"
						label="Todos"
						dense
						hide-details
						class="ma-0 report-toggle"
						@change="onChangeTodos"
						/>
					</v-col>
				</v-row>

				<v-row align="center" class="filters-row mt-3" no-gutters>
					<!-- Tipo de filtro (agora alinhado junto) -->
					<v-col v-if="false" class="col-fixed col-tipo">
						<v-select
						v-model="tipoFiltro"
						:items="tiposFiltro"
						label="Tipo de Filtro"
						item-text="text"
						item-value="value"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-tune-variant"
						/>
					</v-col>

					<v-col v-if="false" class="col-fixed col-tipo">
						<v-select
						v-model="modoRelatorio"
						:items="modosRelatorio"
						label="Visualização"
						item-text="text"
						item-value="value"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-file-eye-outline"
						/>
					</v-col>

					<v-col v-if="false" class="col-fixed col-toggle">
						<v-switch
						v-model="check"
						label="Todos"
						dense
						hide-details
						class="ma-0 report-toggle"
						@change="onChangeTodos"
						/>
					</v-col>

					<v-col class="col-fixed col-user" v-if="!check">
						<v-autocomplete
						:items="usuarios"
						item-text="nome"
						v-model="usuario"
						label="Colaborador"
						dense
						outlined
						hide-details
						clearable
						prepend-inner-icon="mdi-account"
						/>
					</v-col>

					<!-- Mensal -->
					<v-col class="col-fixed col-mes" v-if="tipoFiltro === 'mensal'">
						<v-select
						v-model="mesSelecionado"
						:items="meses"
						label="Mês"
						item-text="nome"
						item-value="numero"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-calendar-month"
						/>
					</v-col>

					<v-col class="col-fixed col-ano" v-if="tipoFiltro === 'mensal'">
						<v-select
						v-model="anoSelecionado"
						:items="anos"
						label="Ano"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-calendar"
						/>
					</v-col>

					<!-- Período -->
					<v-col class="col-fixed col-date" v-if="tipoFiltro === 'periodo'">
						<v-menu
						v-model="menuInicio"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="auto"
						>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							v-model="dataInicio"
							label="Data início"
							outlined
							dense
							hide-details
							prepend-inner-icon="mdi-calendar-start"
							readonly
							v-bind="attrs"
							v-on="on"
							/>
						</template>
						<v-date-picker v-model="dataInicio" @input="menuInicio=false" locale="pt-br" />
					</v-menu>
				</v-col>

				<v-col class="col-fixed col-date" v-if="tipoFiltro === 'periodo'">
					<v-menu
					v-model="menuFim"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
					>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
						v-model="dataFim"
						label="Data fim"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-calendar-end"
						readonly
						v-bind="attrs"
						v-on="on"
						/>
					</template>
					<v-date-picker v-model="dataFim" @input="menuFim=false" locale="pt-br" />
				</v-menu>
			</v-col>

			<!-- Botão -->
			<v-col class="col-fixed col-action">
				<v-btn
				color="primary"
				@click="loadRelatorio"
				:disabled="isBuscarDisabled"
				class="btn-buscar"
				>
				<v-icon small>mdi-magnify</v-icon>
			</v-btn>
		</v-col>
	</v-row>

	<v-row v-if="relatorio.length" class="mt-2">
		<v-col>
			<v-btn color="secondary" dark small @click="generatePDF">
				<v-icon left small>mdi-file-pdf-box</v-icon>
				Exportar PDF
			</v-btn>
		</v-col>
	</v-row>
</v-card-text>
</v-card>

<!-- ================= RELATÓRIO ================= -->
<v-card flat v-if="relatorio.length">
	<v-card-text class="pa-0">
		<div ref="printArea" class="report-content">
			
			<div class="report-header">
				<!-- LOGO -->
				<div class="report-brand">
					<img src="@/img/logoCRG.jpeg" alt="Logo da Empresa" />
				</div>

				<!-- TÍTULO E PERÍODO -->
				<div class="report-center">
					<div class="report-title">Relatório de Ponto</div>

					<div class="report-subtitle">
						<template v-if="tipoFiltro === 'mensal'">
							{{ getNomeMes(mesSelecionado) }}/{{ anoSelecionado }}
						</template>
						<template v-else>
							{{ formatarData(dataInicio) }} a {{ formatarData(dataFim) }}
						</template>
					</div>
				</div>

				<!-- META -->
				<div class="report-meta">
					Gerado em:<br />
					<strong>{{ dataGeracao }}</strong>
				</div>
			</div>


			<div v-for="item in relatorio" :key="item.idfuncionarios || item.nome" class="employee-block">
				<div class="employee-summary-header">
					<div>
						<div class="employee-name">{{ item.nome }}</div>
						<div class="employee-meta">
							Carga horaria: {{ item.carga_horaria || '-' }}h
							<span v-if="item.ferias_resumo && item.ferias_resumo !== '-'"> | Ferias: {{ item.ferias_resumo }}</span>
						</div>
					</div>
					<span class="status" :class="statusPeriodoClass(item)">
						{{ statusPeriodoTexto(item) }}
					</span>
				</div>

				<div class="summary-grid">
					<div class="summary-box">
						<div class="summary-label">Previstas</div>
						<div class="summary-value">{{ item.horasEsperadasBrutas || '00:00' }}</div>
					</div>
					<div class="summary-box">
						<div class="summary-label">Abonadas</div>
						<div class="summary-value">{{ item.horasFolgas || '00:00' }}</div>
					</div>
					<div class="summary-box">
						<div class="summary-label">Esperadas</div>
						<div class="summary-value">{{ item.horasEsperadas || '00:00' }}</div>
					</div>
					<div class="summary-box">
						<div class="summary-label">Trabalhadas</div>
						<div class="summary-value">{{ item.totalHorasTrabalhadas || '00:00' }}</div>
					</div>
					<div class="summary-box emphasis">
						<div class="summary-label">Variacao do periodo</div>
						<div class="summary-value" :class="variacaoClass(item.diferencaMinutos)">
							{{ item.diferencaHoras || '00:00' }}
						</div>
					</div>
					<div v-if="item.saldoHistoricoDisponivel" class="summary-box">
						<div class="summary-label">Saldo anterior</div>
						<div class="summary-value" :class="variacaoClass(item.saldoAnteriorMinutos)">
							{{ minutosParaTempoLocal(item.saldoAnteriorMinutos) }}
						</div>
					</div>
					<div v-if="item.saldoHistoricoDisponivel" class="summary-box">
						<div class="summary-label">Movimento lancado</div>
						<div class="summary-value" :class="variacaoClass(item.movimentoPeriodoMinutos)">
							{{ minutosParaTempoLocal(item.movimentoPeriodoMinutos) }}
						</div>
					</div>
					<div v-if="item.saldoHistoricoDisponivel" class="summary-box emphasis">
						<div class="summary-label">Saldo no fechamento</div>
						<div class="summary-value" :class="variacaoClass(item.saldoFinalPeriodoMinutos)">
							{{ minutosParaTempoLocal(item.saldoFinalPeriodoMinutos) }}
						</div>
					</div>
					<div v-if="temDescontoSalarioResumo(item)" class="summary-box warning">
						<div class="summary-label">Abatimento salarial</div>
						<div class="summary-value">{{ item.horasDescontoSalario || item.totalHorasAbatimentoSalario || '00:00' }}</div>
					</div>
				</div>
				<!-- ===== TABELA ===== -->
				<table v-if="modoRelatorio === 'completo'" class="data-table">
					<thead>
						<tr>
							<th>Data</th>
							<th>Dia</th>
							<th>Entrada</th>
							<th>Saida Almoco</th>
							<th>Retorno</th>
							<th>Saida Final</th>
							<th>Trabalhadas</th>
							<th>Esperadas</th>
							<th>Variacao</th>
							<th>Ocorrencias</th>
							<th>Justificativas</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="(d, i) in item.expedientes" :key="`${i}`" :class="{ ausente: d.ausente, 'sem-expediente': semExpediente(d) }">
							<td>{{ formatarData(d.data) }}</td>
							<td>{{ nomeDia(d.data) }}</td>
							<td>{{ d.entrada || '--:--' }}</td>
							<td>{{ d.saida_almoco || '--:--' }}</td>
							<td>{{ d.retorno || '--:--' }}</td>
							<td>{{ d.saida || '--:--' }}
								<div v-if="d.extra_entrada || d.extra_saida" class="extra-inline info--text">
									Extra: entrada {{ d.extra_entrada || '--:--' }} → saida {{ d.extra_saida || '--:--' }}
								</div>
							</td>
							<td class="horas-cell">
								<div>{{ tempoTrabalhadoDia(d) }}</div>
							</td>
							<td class="horas-cell">
								<div>{{ tempoEsperadoDia(d) }}</div>
							</td>
							<td class="horas-cell">
								<div :class="variacaoClass(variacaoDiaMin(d))">{{ minutosParaTempoLocal(variacaoDiaMin(d)) }}</div>
							</td>

							<td class="obs-cell">
								<span v-if="temObsPrincipal(d)">
									<span class="status status-feriado" v-if="d.feriado">Feriado</span>
									<span class="status status-atestado" v-else-if="d.atestado_comparecimento">Atestado Comparecimento</span>
									<span class="status status-atestado" v-else-if="d.atestado">Atestado</span>
									<span class="status status-acordo" v-else-if="d.acordo">Compensado na Semana</span>
									<span class="status status-folga-feriado" v-else-if="d.folga_feriado">Folga Feriado</span>
									<span class="status status-ferias" v-else-if="d.ferias">Férias</span>
									<span class="status status-folga" v-else-if="d.folga">Folga</span>
									<span class="status status-desconto" v-else-if="isDescontoSalario(d)">Abatimento no Salário</span>
									<span class="status status-domingo" v-else-if="d.domingo">Domingo</span>
									<span class="status status-ausencia" v-else-if="d.ausente">Ausência</span>
								</span>

								<span v-else-if="!d.editado && !d.motivo">-</span>

								<div v-if="d.motivo" class="obs-extra">
									{{ d.motivo }}
								</div>

								<div v-if="d.atestado_comparecimento" class="obs-extra obs-atestado">
									Abono aplicado: {{ d.atestadoComparecimento || minutosParaTempoLocal(d.minutosAtestadoComparecimento) || '00:00' }}
									<span v-if="d.atestado_comparecimento_intervalos && d.atestado_comparecimento_intervalos.length">
										({{ d.atestado_comparecimento_intervalos.join(', ') }})
									</span>
									<div v-if="d.minutosAusenciaCobertaAtestadoComparecimento !== undefined">
										Disponivel pelo atestado: {{ minutosParaTempoLocal(d.minutosAusenciaCobertaAtestadoComparecimento) || '00:00' }}
									</div>
									<div v-if="d.inferidoPorAtestadoComparecimento">
										Batida incompleta: considerado trabalho ate o inicio do atestado.
									</div>
								</div>

								<div v-if="isDescontoSalario(d)" class="obs-extra obs-desconto">
									Folha: {{ d.descontoSalario || minutosParaTempoLocal(d.minutosDescontoSalario) || '00:00' }} para abatimento salarial. Não debita banco de horas.
								</div>

								<div v-if="d.editado" class="edit-box">
									<div class="edit-meta">
										<span><strong>Editado:</strong> {{ d.editado_manualmente ? 'manual' : 'automático' }}</span>
										<span><strong>Por:</strong> {{ d.editado_por || '-' }}</span>
										<span><strong>Em:</strong> {{ formatarData(d.editado_em) }}</span>
									</div>

									<div v-if="d.editado_justificativa" class="edit-just">
										<strong>Justificativa:</strong> {{ d.editado_justificativa }}
									</div>
								</div>
							</td>
							<td class="just-cell">
								<template v-if="temJustificativa(d)">
									<div v-if="d.justificativas?.entrada">
										<strong>Entrada:</strong> {{ d.justificativas.entrada }}
									</div>
									<div v-if="d.justificativas?.saida_almoco">
										<strong>Almoço:</strong> {{ d.justificativas.saida_almoco }}
									</div>
									<div v-if="d.justificativas?.retorno">
										<strong>Retorno:</strong> {{ d.justificativas.retorno }}
									</div>
									<div v-if="d.justificativas?.saida">
										<strong>Saída:</strong> {{ d.justificativas.saida }}
									</div>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</v-card-text>
</v-card>

<!-- Estado vazio -->
<v-card flat v-else-if="searchPerformed" class="text-center pa-8">
	<v-icon size="64" color="grey lighten-1" class="mb-4">mdi-file-search-outline</v-icon>
	<div class="text-h6 grey--text mb-2">Nenhum registro encontrado</div>
	<div class="text-body-2 grey--text">Ajuste os filtros e tente novamente.</div>
</v-card>
			</v-tab-item>

			<v-tab-item value="banco-horas">
				<BancoHoras embedded />
			</v-tab-item>
		</v-tabs-items>
</v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import PageTitle from '@/templates/PageTitle'
import BancoHoras from '@/components/cargahoraria/BancoHoras'
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import { mapState } from 'vuex'
export default {
	name: 'TheRelatorios',
	components: { PageTitle, BancoHoras },
	data () {
		return {
			abaAtiva: 'ponto',
			tipoFiltro: 'mensal',
			modoRelatorio: 'completo',
			modosRelatorio: [
				{ text: 'Completo', value: 'completo' },
				{ text: 'Somente resumo', value: 'resumo' }
				],
			tiposFiltro: [
				{ text: 'Mensal (Mês/Ano)', value: 'mensal' },
				{ text: 'Período (Início/Fim)', value: 'periodo' }
				],
			dataInicio: null, 
			dataFim: null,    
			menuInicio: false,
			menuFim: false,
			usuarios: [],
			usuario: null,
			relatorio: [],
			check: false,
			mesSelecionado: null,
			anoSelecionado: new Date().getFullYear(),
			searchPerformed: false,
			meses: [
				{ nome: 'Janeiro', numero: 1 },
				{ nome: 'Fevereiro', numero: 2 },
				{ nome: 'Março', numero: 3 },
				{ nome: 'Abril', numero: 4 },
				{ nome: 'Maio', numero: 5 },
				{ nome: 'Junho', numero: 6 },
				{ nome: 'Julho', numero: 7 },
				{ nome: 'Agosto', numero: 8 },
				{ nome: 'Setembro', numero: 9 },
				{ nome: 'Outubro', numero: 10 },
				{ nome: 'Novembro', numero: 11 },
				{ nome: 'Dezembro', numero: 12 }
				],
			anos: Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i)
		}
	},
	computed: {
		...mapState(['user']),
		dataGeracao () {
			return new Date().toLocaleDateString('pt-BR')
		},
		isBuscarDisabled () {
			if (this.check) {
				if (this.tipoFiltro === 'mensal') return !this.mesSelecionado || !this.anoSelecionado
					return !this.dataInicio || !this.dataFim
			} else {
				if (!this.usuario) 
					return true
				if (this.tipoFiltro === 'mensal') return !this.mesSelecionado || !this.anoSelecionado
					return !this.dataInicio || !this.dataFim
			}
		}
	},

	watch: {
		abaAtiva(value) {
			if (this.$route.query.tab === value) return
			this.$router.replace({ query: { ...this.$route.query, tab: value } }).catch(() => {})
		},
		'$route.query.tab'(value) {
			if (value === 'banco-horas' || value === 'ponto') this.abaAtiva = value
		}
	},

	methods: {
		onChangeTodos(value) {
			if (value) this.usuario = null
		},
		isDescontoSalario(d) {
			return !!(d && (d.desconto_salario || d.desconto_salarial))
		},
		temDescontoSalarioResumo(item) {
			const valor = item?.horasDescontoSalario || item?.totalHorasAbatimentoSalario
			return !!valor && valor !== '00:00'
		},
		minutosParaTempoLocal(totalMinutos) {
			if (totalMinutos === null || totalMinutos === undefined || totalMinutos === '') return null
				const sinal = Number(totalMinutos || 0) < 0 ? '-' : ''
			const m = Math.abs(Number(totalMinutos || 0))
			const h = Math.floor(m / 60)
			const mm = m % 60
			return `${sinal}${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
		},
		tempoParaMinutos(valor) {
			if (valor === null || valor === undefined || valor === '') return 0
			if (typeof valor === 'number') return Math.trunc(valor)

			const texto = String(valor).trim()
			const negativo = texto.startsWith('-')
			const partes = texto.replace('-', '').split(':').map(Number)
			if (partes.length < 2 || partes.some(Number.isNaN)) return 0

			const minutos = (partes[0] * 60) + partes[1]
			return negativo ? -minutos : minutos
		},
		minutosDia(d, minuteKeys = [], timeKeys = []) {
			for (const key of minuteKeys) {
				if (d && d[key] !== null && d[key] !== undefined && d[key] !== '') return Math.trunc(Number(d[key] || 0))
			}

			for (const key of timeKeys) {
				if (d && d[key]) return this.tempoParaMinutos(d[key])
			}

			return 0
		},
		tempoTrabalhadoDia(d) {
			const minutos = this.minutosDia(d, ['minutosTrabalhados'], ['horas'])
			return this.minutosParaTempoLocal(minutos) || '00:00'
		},
		tempoEsperadoDia(d) {
			const minutos = this.minutosDia(d, ['minutosEsperadosDia', 'minutosEsperadosBancoDia'], ['horasEsperadasDia'])
			return this.minutosParaTempoLocal(minutos) || '00:00'
		},
		variacaoDiaMin(d) {
			if (d && d.deltaMin !== null && d.deltaMin !== undefined) return Math.trunc(Number(d.deltaMin || 0))

			const trabalhado = this.minutosDia(d, ['minutosTrabalhados'], ['horas'])
			const esperado = this.minutosDia(d, ['minutosEsperadosDia', 'minutosEsperadosBancoDia'], ['horasEsperadasDia'])
			return trabalhado - esperado
		},
		variacaoClass(totalMinutos) {
			const valor = Number(totalMinutos || 0)
			if (valor > 0) return 'success--text text--darken-1'
			if (valor < 0) return 'error--text text--darken-1'
			return 'grey--text text--darken-1'
		},
		statusPeriodoTexto(item) {
			const valor = Number(item?.diferencaMinutos || 0)
			if (valor > 0) return 'Credito no periodo'
			if (valor < 0) return 'Debito no periodo'
			return 'Em dia'
		},
		statusPeriodoClass(item) {
			const valor = Number(item?.diferencaMinutos || 0)
			if (valor > 0) return 'status-credito'
			if (valor < 0) return 'status-ausencia'
			return 'status-neutro'
		},
		nomeDia(data) {
			if (!data) return '-'
			const dias = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab']
			const indice = moment(data, 'YYYY-MM-DD').day()
			return dias[indice] || '-'
		},
		temObsPrincipal(d) {
			return (
				d.feriado ||
				d.atestado ||
				d.atestado_comparecimento ||
				d.acordo ||
				d.folga_feriado ||
				d.ferias ||
				d.folga ||
				d.domingo ||
				this.isDescontoSalario(d) ||
				d.ausente
				)
		},
		semExpediente(d) {
			return !d.entrada && !d.saida_almoco && !d.retorno && !d.saida
		},
		isUsuarioAtivo(usuario) {
			if (!usuario) return false

				const valor = usuario.ativo !== undefined && usuario.ativo !== null
			? usuario.ativo
			: usuario.status

			if (valor === undefined || valor === null || valor === '') return true
				if (valor === true || valor === 1) return true
					if (valor === false || valor === 0) return false

						const status = String(valor)
					.trim()
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')

					return ['1', 'true', 'ativo', 'sim', 'a'].includes(status)
				},

				async loadUsers () {
					try {
						const res = await axios.get(`${baseApiUrl}/usuarios`)
						const usuarios = Array.isArray(res.data) ? res.data : []

						this.usuarios = usuarios
						.filter(usuario => this.isUsuarioAtivo(usuario))
						.sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'))
					} catch (error) {
						showError(error)
					}
				},

				async loadRelatorio() {
					const params = {}

					if (this.tipoFiltro === 'mensal') {
						if (!this.mesSelecionado || !this.anoSelecionado) {
							this.$toasted.error('Selecione mês e ano.')
							return
						}
						params.mes = this.mesSelecionado
						params.ano = this.anoSelecionado
					} else {
						if (!this.dataInicio || !this.dataFim) {
							this.$toasted.error('Selecione data início e data fim.')
							return
						}
    // garante ordem correta
						if (this.dataInicio > this.dataFim) {
							this.$toasted.error('A data início não pode ser maior que a data fim.')
							return
						}
						params.data_inicio = this.dataInicio
						params.data_fim = this.dataFim
					}

					try {
						if (this.check) {
							const res = await axios.get(`${baseApiUrl}/relatorios`, { params })
							this.relatorio = res.data
						} else if (this.usuario) {
							params.usuario = this.usuario
							const res = await axios.get(`${baseApiUrl}/relatorios`, { params })
							this.relatorio = res.data
						}

						this.searchPerformed = true
					} catch (error) {
						showError(error)
						this.searchPerformed = true
					} finally {
						this.usuario = null
					}
				},


				generatePDF () {
					const first_name = this.relatorio.map(n => n.nome.split(' ')[0])
					const element = this.$refs.printArea
					const options = {
						margin: [6, 6, 6, 6],
						filename: `relatorio_${this.modoRelatorio}_${first_name}_${this.mesSelecionado}_${this.anoSelecionado}.pdf`,
						image: { type: 'jpeg', quality: 0.98 },
						html2canvas: { scale: 2, useCORS: true },
						jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
					}

					this.$nextTick(() => {
						setTimeout(() => {
							html2pdf().set(options).from(element).save()
						}, 250)
					})
				},

				getNomeMes (numero) {
					const mes = this.meses.find(m => m.numero === numero)
					return mes ? mes.nome : ''
				},

				formatarData (data) {
					return data ? moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY') : '--/--/----'
				},

				temJustificativa (d) {
					const j = d?.justificativas
					if (!j) return false
						return !!(j.entrada || j.saida_almoco || j.retorno || j.saida)
				}
			},
			mounted () {
				if (this.$route.query.tab === 'banco-horas') this.abaAtiva = 'banco-horas'
				this.loadUsers()
			}
		}
		</script>

		<style scoped>
/*BASE DO RELATÓRIO */

.reports-tabs-card {
	background-color: #fafafa;
	border: 1px solid #eeeeee;
}

.transparent-tabs {
	background: transparent;
}

.report-content {
	padding: 6px;
	font-size: 10px;
	color: #333;
}

.employee-block {
	margin-top: 12px;
	page-break-inside: avoid;
	border: 1px solid #e0e0e0;
	border-radius: 6px;
	padding: 8px;
	background: #fff;
}


/* 
   HEADER / BRAND PROFISSIONAL
    */

.report-header {
	display: grid;
	grid-template-columns: 140px 1fr 140px;
	align-items: center;
	gap: 12px;
	padding-bottom: 8px;
	margin-bottom: 8px;
	border-bottom: 1px solid #e5e5e5;
}

/* LOGO */
.report-brand {
	display: flex;
	align-items: center;
}

.report-brand img {
	height: 60px;
	max-width: 100%;
	object-fit: contain;
}

/* CENTRO */
.report-center {
	text-align: center;
}

.report-title {
	font-size: 14px;
	font-weight: 700;
	line-height: 1.2;
}

.report-subtitle {
	font-size: 10px;
	color: #666;
	margin-top: 2px;
}

/* META */
.report-meta {
	text-align: right;
	font-size: 9px;
	color: #666;
	line-height: 1.2;
	white-space: nowrap;
}


.report-title {
	font-size: 13px;
	font-weight: 700;
}

.report-subtitle {
	font-size: 10px;
	color: #666;
}

.employee-name {
	font-size: 13px;
	font-weight: 700;
}

.employee-summary-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 10px;
	padding-bottom: 6px;
	margin-bottom: 8px;
	border-bottom: 1px solid #eeeeee;
}

.employee-meta {
	font-size: 9px;
	color: #666;
	margin-top: 2px;
}

.summary-grid {
	display: grid;
	grid-template-columns: repeat(6, minmax(0, 1fr));
	gap: 6px;
	margin-bottom: 8px;
}

.summary-box {
	border: 1px solid #eeeeee;
	border-radius: 5px;
	padding: 6px;
	background: #fafafa;
	min-height: 42px;
}

.summary-box.emphasis {
	background: #fff;
	border-color: #d6d6d6;
}

.summary-box.warning {
	background: #fff8e1;
	border-color: #ffe0b2;
}

.summary-label {
	font-size: 8px;
	color: #666;
	margin-bottom: 2px;
}

.summary-value {
	font-size: 11px;
	font-weight: 700;
	line-height: 1.2;
}

/*
   TABELA
   */

.data-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 8.5px;
}

.data-table th,
.data-table td {
	border: 1px solid #cfcfcf;
	padding: 4px 3px;
	text-align: center;
	vertical-align: top;
}

.data-table th {
	background: #424242;
	color: #fff;
	font-weight: 700;
}

/* linhas especiais */
tr.sem-expediente {
	background-color: #f7f7f7;
	color: #666;
}

tr.ausente {
	background-color: #fdeaea;
	color: #8a1f1f;
}

tr.ausente.sem-expediente {
	background-color: #fdeaea;
}


.horas-cell {
	text-align: center !important;
	vertical-align: middle !important;
}

.extra-inline {
	margin-top: 1px;
	font-size: 8px;
	line-height: 1;
	color: #666;
	white-space: nowrap;
}

/*
   STATUS (Domingo, Feriado, Férias, etc.)
   */

.status {
	font-weight: 600;
	padding: 2px 6px;
	border-radius: 4px;
	font-size: 9px;
	display: inline-block;
}

.status-feriado {
	background: #ede9fe;
	color: #5b21b6;
}

.status-ferias {
	background: #dcfce7;
	color: #166534;
}

.status-domingo {
	background: #e0f2fe;
	color: #075985;
}

.status-folga,
.status-folga-feriado {
	background: #fef9c3;
	color: #854d0e;
}

.status-desconto {
	background: #fee2e2;
	color: #991b1b;
}
.status-ausencia {
	background: #fee2e2;
	color: #991b1b;
}

.status-atestado {
	background: #fff7ed;
	color: #9a3412;
}

.status-acordo {
	background: #e5e7eb;
	color: #374151;
}

.status-credito {
	background: #dcfce7;
	color: #166534;
}

.status-neutro {
	background: #e5e7eb;
	color: #374151;
}

/*
   OBSERVAÇÕES / JUSTIFICATIVAS
   */

.obs-cell {
	text-align: left !important;
	vertical-align: top !important;
	padding: 4px 6px !important;
}

.obs-extra {
	margin-top: 2px;
	font-size: 10px;
	color: #666;
}

.just-cell {
	text-align: left;
	font-size: 8px;
}

.edit-box {
	margin-top: 3px;
	font-size: 10px;
	color: #666;
}

.edit-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.edit-meta span {
	white-space: nowrap;
}

.edit-just {
	margin-top: 2px;
}

/*
   FILTROS
   */

.filters-row,
.filters-mode-row {
	display: flex;
	flex-wrap: wrap !important;
	gap: 10px;
}

.col-fixed {
	flex: 0 1 auto !important;
	padding: 0 !important;
}

.col-tipo { width: 210px; }
.col-mode {
	width: 170px;
	display: flex;
	align-items: center;
}
.col-user {
	width: 280px;
	flex-grow: 1 !important;
}
.col-mes  { width: 170px; }
.col-ano  { width: 120px; }
.col-date { width: 180px; }
.col-toggle {
	width: 96px;
	display: flex;
	align-items: center;
}
.col-action {
	width: 48px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-left: auto;
}

.btn-buscar {
	min-width: 40px !important;
	height: 40px;
	padding: 0 !important;
}

.report-toggle {
	height: 40px;
	display: flex;
	align-items: center;
}

@media (max-width: 960px) {
	.summary-grid {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.col-tipo,
	.col-mode,
	.col-user,
	.col-mes,
	.col-ano,
	.col-date {
		width: calc(50% - 5px);
	}

	.col-toggle {
		width: calc(50% - 5px);
	}

	.col-action {
		width: 100%;
		margin-left: 0;
		justify-content: flex-end;
	}
}

@media (max-width: 600px) {
	.summary-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.employee-summary-header {
		flex-direction: column;
	}

	.col-tipo,
	.col-mode,
	.col-user,
	.col-mes,
	.col-ano,
	.col-date,
	.col-toggle,
	.col-action {
		width: 100%;
	}

	.col-action .btn-buscar {
		width: 100%;
	}
}

/* remove espaços extras do Vuetify */
:deep(.v-input__slot) {
	margin-bottom: 0 !important;
}
:deep(.v-text-field__details),
:deep(.v-messages) {
	display: none !important;
}

/*TAGS*/

.tag {
	font-size: 9px;
	font-weight: 400;
	padding: 1px 4px;
	border-radius: 3px;
	white-space: nowrap;
}

.tag-previstas {
	background: #e5e7eb;
	color: #374151;
}

.tag-desconto {
	background: #fee2e2;
	color: #991b1b;
}

.obs-desconto {
	color: #991b1b;
	font-weight: 600;
}

/*
   PRINT
   */

@media print {
	.v-btn,
	.v-card,
	.v-container {
		box-shadow: none !important;
	}
}
</style>
